<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('StatisticsList.list.Statistical Report') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-4">
                        <label for="mobileuser">{{ $t('StatisticsList.list.Statistics Report Type') }}</label>
                        <Dropdown id="state" v-model="ReportSelectType" :options="reportType" optionLabel="name" placeholder="리포트 유형을 선택하세요" @change="disableEnable" :class="`${error.stype ? 'p-invalid' : ''}`"></Dropdown>
                        <div class="text-red">{{ error.stype }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="mobileuser">{{ $t('StatisticsList.list.Product Category') }}</label>
                        <Dropdown id="state" v-model="productCategorySelectType" :options="ProductCategory" optionLabel="name" placeholder="Choose Product Type" :disabled="IsDisable"></Dropdown>
                        <div class="text-red">{{ error.mobile }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-d-flex p-jc-start">
                <div>
                    <ConfirmPopup></ConfirmPopup>
                    <Button label="help" class="p-button p-mr-2 p-mb-2" @click="confirm($event)"><i class="pi pi-check p-mr-2"></i>{{$t('StatisticsList.list.Send Statistics Report')}}</Button>
                </div>
                <!-- <div>
                    <Button @click="$router.go(-1)" label="Go Back" class="p-button-outlined p-mr-2 p-mb-2" />
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import StatisticsService from '../../service/API/StatisticsService';
import validatesendReport from '../../validations/statistics/validatesendReport';
export default {
    data() {
        return {
            reportType: [
                { name: 'Purchase Statistics Report', code: 'purchase_statistic_report' },
                { name: 'Category Statistics Report', code: 'category_statistic_report' },
            ],
            ProductCategory: [
                { name: 'First Product Category', code: '1' },
                { name: 'Second Product Category', code: '2' },
                { name: 'Third Product Category', code: '3' },
            ],
            selected: [],
            selectedItemss: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            customer1: null,
            loading1: false,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            error: {},
            //params for list
            ReportSelectType: '',
            productCategorySelectType: '',
            IsDisable: true,
        };
    },
    created() {
        this.statisticsService = new StatisticsService();
    },
    methods: {
        disableEnable() {
            if (this.ReportSelectType.code == 'purchase_statistic_report') {
                this.IsDisable = false;
            } else {
                this.IsDisable = true;
            }
        },
        confirm(event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    console.log(this.ReportSelectType);
                     let vcheckData = {
                        stype: this.ReportSelectType.code==undefined?'':'something',
                    };
                    console.log(vcheckData);
                    const { isInvalid, error } = validatesendReport(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.error = {};
                        this.statisticsService.sendReport(this.ReportSelectType.code==undefined?'':this.ReportSelectType.code, this.productCategorySelectType.code==undefined?'':this.productCategorySelectType.code).then(() => {
                        this.$toast.add({ severity: 'success', summary: '성공 메세지', detail: '통계 리포트가 성공적으로 전송되었습니다. ', life: 3000 });
                    });
                    }
                    
                },
                reject: () => {
                    //callback to execute when user rejects the action
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
</style>
